import QueryString from 'query-string'

interface EnvParams {
  includeScrum: boolean
}

const env = (params: EnvParams = { includeScrum: true }) => {
  const matchHost = /(scrum\d\d\d|scrum\d\d|scrum\d|dev)/.exec(window.location.host)
  if (matchHost) {
    const [full, group] = matchHost
    const combined = full && group
    return params.includeScrum ? combined : combined.replace('scrum', '')
  }
  const regexHref = `${window.location.host}/(\\d\\d\\d|\\d\\d|\\d)/`
  const matchHref = new RegExp(regexHref).exec(window.location.href)
  if (matchHref && matchHref.length > 1) {
    return params.includeScrum ? `scrum${matchHref[1]}` : matchHref[1]
  }

  const { env = 'prod' } = QueryString.parse(window.location.host)
  const result = Array.isArray(env) ? env[0] : env
  return params.includeScrum ? result : result.replace('scrum', '')
}

export const getScrumNumber = () => {
  const scrumHost = /(scrum\d\d\d|scrum\d\d|scrum\d|dev)/.exec(window.location.host)
  if (scrumHost) {
    const scrumNumber = scrumHost[0].match(/\d+/)
    if (scrumNumber) {
      return scrumNumber[0]
    }
  }
}

export default env
